import { TrendingUp, TrendingDown } from 'lucide-react';
import type { MetricData } from '@/types';

interface MetricCardProps {
  metric: MetricData;
  icon?: React.ReactNode;
}

export default function MetricCard({ metric, icon }: MetricCardProps) {
  const isPositive = metric.changeType === 'increase';

  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500">{metric.name}</p>
          <p className="mt-2 text-3xl font-bold text-gray-900">
            {typeof metric.value === 'number' && metric.value % 1 !== 0
              ? metric.value.toFixed(1)
              : metric.value.toLocaleString()}
          </p>
        </div>
        {icon && (
          <div className="rounded-lg bg-primary-50 p-2.5 text-primary-600">
            {icon}
          </div>
        )}
      </div>
      <div className="mt-4 flex items-center gap-1.5">
        {isPositive ? (
          <TrendingUp className="h-4 w-4 text-green-500" />
        ) : (
          <TrendingDown className="h-4 w-4 text-red-500" />
        )}
        <span
          className={`text-sm font-medium ${
            isPositive ? 'text-green-600' : 'text-red-600'
          }`}
        >
          {Math.abs(metric.change)}%
        </span>
        <span className="text-sm text-gray-500">vs last quarter</span>
      </div>
    </div>
  );
}
